var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStripesRight = function SvgStripesRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1653.801 1380.385",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1062.377 352.731l201.23-201.229",
    stroke: "var(--color)",
    fill: "none",
    fillRule: "evenodd",
    strokeWidth: 140,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1427.435 1179.855l98.07-98.07",
    stroke: "var(--color)",
    fill: "none",
    fillRule: "evenodd",
    strokeWidth: 140,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1267.63 942.268l454.661-454.663",
    stroke: "var(--color)",
    fill: "none",
    fillRule: "evenodd",
    strokeWidth: 140,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1523.602 288.901l260.745-260.747",
    stroke: "var(--color)",
    fill: "none",
    fillRule: "evenodd",
    strokeWidth: 140,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M916.793 1690.498l315.66-315.66",
    stroke: "var(--color)",
    fill: "none",
    fillRule: "evenodd",
    strokeWidth: 140,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M458.587 1751.309l454.663-454.662",
    stroke: "var(--color)",
    fill: "none",
    fillRule: "evenodd",
    strokeWidth: 140,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M714.56 1097.942l260.746-260.746",
    stroke: "var(--color)",
    fill: "none",
    fillRule: "evenodd",
    strokeWidth: 140,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M1523.603 288.9L1784.35 28.154",
    stroke: "var(--color)",
    fill: "none",
    fillRule: "evenodd",
    strokeWidth: 140,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M218.878 1196.231l201.228-201.229",
    stroke: "var(--color)",
    fill: "none",
    fillRule: "evenodd",
    strokeWidth: 140,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M383.117 1429.385l102.001-102",
    stroke: "var(--color)",
    fill: "none",
    fillRule: "evenodd",
    strokeWidth: 140,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M1192.16 620.343l102.001-102.001",
    stroke: "var(--color)",
    fill: "none",
    fillRule: "evenodd",
    strokeWidth: 140,
    strokeLinecap: "round"
  })));
};
export default SvgStripesRight;